var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFee(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 54,
    rx: 5,
    fill: "#6764FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.1894 43.4438C26.6549 43.6923 27.2392 43.6908 27.7047 43.4422C40.3903 36.6275 41.2912 23.3133 41.2802 19.5275C41.279 19.2232 41.189 18.9259 41.0214 18.672C40.8538 18.418 40.6158 18.2185 40.3365 18.0978L27.5907 12.4516C27.3878 12.3622 27.1685 12.3161 26.9469 12.3164C26.7252 12.3167 26.506 12.3633 26.3034 12.4532L13.6462 18.0993C13.3711 18.2201 13.1364 18.4175 12.9702 18.6679C12.804 18.9183 12.7133 19.2112 12.7089 19.5117C12.6551 23.2784 13.4135 36.6212 26.1894 43.4438ZM21.7339 25.2972L25.3645 28.9278L32.1617 22.1305L34.4006 24.3693L25.3645 33.4054L19.4951 27.536L21.7339 25.2972Z",
    fill: "#F7F6FF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFee);
export default __webpack_public_path__ + "static/media/Fee.55f39640d2890cd975af9e58b6752cca.svg";
export { ForwardRef as ReactComponent };